// @mui
import { enUS, arSA } from '@mui/material/locale';

// LANGUAGE MANAGEMENT:
// Language is now managed by a centralized system using localStorage key 'foodo-language'
// Clear localStorage if there are language/direction issues:
// localStorage.removeItem('foodo-language'); localStorage.removeItem('settings');
//
// Debug language issues by running in console:
// console.log('localStorage foodo-language:', localStorage.getItem('foodo-language'));
// console.log('localStorage settings:', localStorage.getItem('settings'));
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: 'flagpack:gb-nir',
  },
  {
    label: 'Arabic',
    value: 'ar',
    systemValue: arSA,
    icon: 'flagpack:qa',
  },
];

export const defaultLang = allLangs[1]; // Arabic

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
